import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IAddedItem } from 'components/input/add-multiple/add-multiple.component';
import { ValidationDirective } from 'directives/validation.directive';
import { InputType } from 'enums/InputType';
import { ReplyType } from 'enums/ReplyType';
import { SelectListItemModel } from 'models/SelectList';
import { Inputs } from 'modules/inputs';
import { TranslatePipe } from 'pipes/translate.pipe';

export interface ReplyView {
	index: number, companyId: string, orderId?: string, orderLineId?: string, taskflowId?: string, replies: unknown[], checkBoxReplies: boolean[]
}

interface ReplyGroupData {
	replyView: ReplyView,
	type: ReplyType,
	numberOfReplies: number,
	displayIndex?: string,
	inputType?: InputType,
	selectList?: SelectListItemModel[]
}

@Component({
	selector: 'questionnaire-input',
	templateUrl: './questionnaire-input.component.html',
	imports: [Inputs, FormsModule, ValidationDirective, TranslatePipe]
})
export class QuestionnaireInputComponent {

	@Input() public set data(value: ReplyGroupData) {
		this.replyView = value.replyView;
		this.type = value.type;
		this.numberOfReplies = value.numberOfReplies;
		this.displayIndex = value.displayIndex;
		this.inputType = value.inputType;
		this.selectList = value.selectList;

		if (this.type == ReplyType.AddMultiple) {
			for (let i = 0; i < this.numberOfReplies; i++) {
				const stringArray = this.replyView.replies[i] as string[];
				this.multiLists[i] = this.replyView.replies[i] && stringArray.map ? stringArray.map(reply => { return { value: reply, label: reply }; }) : [];
			}
		}
	}

	@Input() public replyView!: ReplyView;
	@Input() public type!: ReplyType;
	@Input() public numberOfReplies!: number;
	@Input() public displayIndex?: string;
	@Input() public inputType?: InputType;
	@Input() public selectList?: SelectListItemModel[];

	@Output() public onUpdate = new EventEmitter<void>();

	public replyType = ReplyType;
	public multiLists: IAddedItem[][] = []; // View model compatible with the Add-Multiple component

	public get stringReplies() {
		return this.replyView.replies as string[];
	}
	public get addMultipleReplies() {
		return this.replyView.replies as (string[] | null)[];
	}

	updateAddMultiple(index: number) {
		this.replyView.replies[index] = this.multiLists[index].length == 0 ? null : this.multiLists[index].map(item => item.label);
		this.onUpdate.emit();
	}
}
